export const RESULT_OK = '0';
export const RESULT_EMPTY_REWARD = '22';
export const RESULT_DUPLICATED_REQUEST = '24';
export const RESULT_ALREADY_REGISTER = '25';
export const RESULT_WEEK_LIST_OVER_DURATION = '1001';
export const RESULT_CODE_TEMPLATE_CODE_WITH_PROGRAM = '1002';
export const RESULT_EMPTY_QUESTION = '1003';
